import { Application } from '@/models/Application';
import { DynamicAttributes } from '@/models/DynamicAttributes';
import { Module } from '@/models/Module';
import { Organization } from '@/models/Organization';
import { OrganizationStats } from '@/models/OrganizationStats';
import { PasswordRules } from '@/models/PasswordRules';

export enum AppOrganizationTypes {
    GET_APP_ORGANIZATION_REQUEST = '@appOrganization/GET_APP_ORGANIZATION_REQUEST',
    GET_APP_ORGANIZATION_SUCCESS = '@appOrganization/GET_APP_ORGANIZATION_SUCCESS',
    GET_APP_ORGANIZATION_FAILURE = '@appOrganization/GET_APP_ORGANIZATION_FAILURE',

    SET_CONFIG_REQUEST = '@appOrganization/SET_CONFIG_REQUEST',
    SET_CONFIG_SUCCESS = '@appOrganization/SET_CONFIG_SUCCESS',
    SET_CONFIG_FAILURE = '@appOrganization/SET_CONFIG_FAILURE',

    GET_PASSWORD_RULES_REQUEST = '@appOrganization/GET_PASSWORD_RULES_REQUEST',
    GET_PASSWORD_RULES_SUCCESS = '@appOrganization/GET_PASSWORD_RULES_SUCCESS',
    GET_PASSWORD_RULES_FAILURE = '@appOrganization/GET_PASSWORD_RULES_FAILURE',

    GET_ORGANIZATION_STATS_REQUEST = '@appOrganization/GET_ORGANIZATION_STATS_REQUEST',
    GET_ORGANIZATION_STATS_SUCCESS = '@appOrganization/GET_ORGANIZATION_STATS_SUCCESS',
    GET_ORGANIZATION_STATS_FAILURE = '@appOrganization/GET_ORGANIZATION_STATS_FAILURE',
}

export interface SetConfigRequestData {
    color: string;
    logo?: string;
    banner?: string;
    bannerActivated: boolean;
    hasBanner: boolean;
}

export interface AppOrganization {
    application: Application;
    organization: Organization;
    colors: string[];
    customLogoFileName: string;
    totalLicenses: number;
    passwordRules: PasswordRules;
    modules: Module[];
    stats: OrganizationStats;
    isWhiteLabel: boolean;
    isTotvs: boolean;
    dynamicAttributes: DynamicAttributes;
    url: string;
}

export interface AppOrganizationState {
    data: AppOrganization;
    loading: boolean;
    hasError: boolean;
    success: boolean;
}
